import { CATEGORIES } from '@/mocks/categories';

interface FilterBarProps {
  activeCat: string;
  keyword: string;
  resultCount: number;
  total: number;
  onCategoryChange: (id: string) => void;
  onKeywordChange: (value: string) => void;
  onReset: () => void;
}

export default function FilterBar({
  activeCat,
  keyword,
  resultCount,
  total,
  onCategoryChange,
  onKeywordChange,
  onReset,
}: FilterBarProps) {
  const options = [{ id: 'all', name: '全部档案' }, ...CATEGORIES.map((c) => ({ id: c.id, name: c.name }))];
  const filtered = activeCat !== 'all' || keyword.trim() !== '';

  return (
    <div className="w-full rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-6">
      <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6">
        <div className="flex-1">
          <div className="flex flex-wrap gap-2">
            {options.map((option) => {
              const active = activeCat === option.id;
              return (
                <button
                  key={option.id}
                  type="button"
                  onClick={() => onCategoryChange(option.id)}
                  className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                    active
                      ? 'bg-primary-500 border-primary-500 text-background-50'
                      : 'bg-transparent border-background-300 text-foreground-700 hover:border-primary-500 hover:text-primary-500'
                  }`}
                >
                  {option.name}
                </button>
              );
            })}
          </div>
        </div>

        <div className="w-full lg:w-80 shrink-0">
          <div className="relative">
            <span className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="search"
              value={keyword}
              onChange={(e) => onKeywordChange(e.target.value)}
              placeholder="搜索标题、标签或档案编号"
              aria-label="搜索考古档案"
              className="w-full pl-11 pr-4 py-2.5 text-sm rounded-md bg-background-50 border border-background-300 text-foreground-900 placeholder:text-foreground-500 focus:outline-none focus:border-primary-500 focus:ring-1 focus:ring-primary-500/60 transition-colors"
            />
          </div>
        </div>
      </div>

      <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between gap-4">
        <p className="text-xs text-foreground-600">
          共找到 <span className="text-primary-500 font-medium">{resultCount}</span> 条记录
          {filtered ? `（全部 ${total} 条）` : ''}
        </p>
        {filtered && (
          <button
            type="button"
            onClick={onReset}
            className="inline-flex items-center gap-1.5 text-xs text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line"></i>
            重置筛选
          </button>
        )}
      </div>
    </div>
  );
}